import React, { Fragment, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { PowerTable, Pagination, NoInformationFound } from 'Components';
import { cleanSearchParams, urlSearchToObject } from 'helpers/urlSearchParams';
import PrepaidRequestHeader from '../PrepaidRequestHeader/PrepaidRequestHeader';
import './PrepaidRequestDesktop.css';

const PrepaidRequestDesktop = (props) => {
  const showNoInformationFound =
    !props.data.isLoading && props.data.data.length === 0;

  const getPaymentStatus = (status, prepiadStatus) => {
    let translateKey;
    switch (prepiadStatus) {
      case 'D': translateKey = i18n.t('jobs:Draft'); break;
      case 'E': translateKey = i18n.t('jobs:Pending'); break;
      case 'P': translateKey = i18n.t('jobs:Paid'); break;
      case 'C': translateKey = i18n.t('jobs:Cancelled'); break;
      case 'O': translateKey = i18n.t('jobs:Overridden'); break;
      default: break;
    }
    return status.trim() === translateKey.trim() ? status : `${status}/${translateKey}`;
  }
  const jobs = useMemo(() => {
    return (props.data.data || []).map((item) => ({
      ...item,
      UserLOB: props.userInfo.LOB,
      IsInternalUser: props.userInfo.IsInternalUser,
      StatusName: item.RequestStatus === '' ? item.StatusName : getPaymentStatus(item.StatusName, item.RequestStatus),
      Type: item.IsPrepaidOrder ? i18n.t('jobs:Order') : i18n.t('jobs:Job'),
    }));
  }, [props.data.data]);

  const paginationProps = {
    onClick: props.onPageChange,
    currentPage: props.data.pageNumber,
    itemsPerPage: props.data.pageSize,
    totalItems: props.data.totalItems,
  };

  return (
    <div className="jobs-desktop">
      <PrepaidRequestHeader
        tabs={props.tabs}
        tabIndex={props.data.tabIndex}
        onTabsClick={props.handleTabClick}
        onPageSizeChange={props.onPageSizeChange}
        showNoInformationFound={showNoInformationFound}
        isSubmissionWarningON={props.isSubmissionWarningON}
        deleteSelectedItems={props.deleteSelectedItems}
        setAppState={props.setAppState}
        pageSize={props.pageSizes}/>

        {showNoInformationFound
          ? (
            <NoInformationFound
              titleText={i18n.t('jobs:NoJobs')}
              subText={i18n.t('jobs:NewJob1')}
              linkText={i18n.t('jobs:NewJob')}
              link="/submissions/new"
            />
          )
          : (
            <Fragment>
              <PowerTable
                {...props.data}
                data={jobs}
                keys={props.data.tabIndex === 4 ? props['prepaidAll'].keys : props['submittedJobsKeyPairs'].keys}
                keyPairs={props.data.tabIndex === 4 ? props['prepaidAll'].keyPairs : props['submittedJobsKeyPairs'].keyPairs}
                tabIndex={props.data.tabIndex}
                popoverRef={props.popoverRef}
                powerTableIndex={props.powerTableIndex}
                powerTableCode={props.powerTableCode}
                onOptionClick={props.onOptionClick}
                viewCode={props.data.tabIndex === 4 ? props['prepaidAll'].viewCode : props['submittedJobsKeyPairs'].viewCode}
                handleSortClick={(newSort) =>
                  props.handleSorting({ shouldLoad: true, sort: newSort, pageNumber: 1, })
                 }
                hasManualSort
                setPageState={props.setPageState}
                setAppState={props.setAppState}
                menuOptions={props.menuOptions}
                rowRules={props.rowRules}
                isSupplyWarningON={props.isSupplyWarningON}
                isTemplateWarningON={props.isTemplateWarningON}
                isSubmissionWarningON={props.isSubmissionWarningON}
              />
              <div className="jobs-desktop__pagination">
                <Pagination {...paginationProps} />
              </div>
            </Fragment>
          )}
    </div>
  );
};

PrepaidRequestDesktop.propTypes = {
  popoverRef: PropTypes.shape({}),
  powerTableIndex: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  data: PropTypes.shape({
    pageSize: PropTypes.number,
    totalItems: PropTypes.number,
    isLoading: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    tabIndex: PropTypes.number,
    pageNumber: PropTypes.number,
  }),
  onPaginationClick: PropTypes.func,
  setAppState: PropTypes.func,
  setPageState: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.string),
  handleTabClick: PropTypes.func,
  powerTableCode: PropTypes.string,
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  rowRules: PropTypes.func,
  userInfo: PropTypes.shape({
    LOB: PropTypes.string,
    IsInternalUser: PropTypes.bool,
  }),
  pageSizes: PropTypes.arrayOf(PropTypes.number),
  onPageChange: PropTypes.func,
  onOptionClick: PropTypes.func,
};

export default PrepaidRequestDesktop;



// WEBPACK FOOTER //
// ./src/containers/PrepaidRequest/PrepaidRequestDesktop/PrepaidRequestDesktop.jsx